"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _setSceneLayers = _interopRequireDefault(require("./setSceneLayers"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * This will be called after another director logs in
 * and updates either `background` or `overlay`,
 * it will emit `SCENE_LAYERS_UPDATED` event,
 * to will ensure all other directors to have updated scene layers
 * @param {Array} sceneLayers
 */
function syncSceneLayers(sceneLayers) {
  return function (dispatch) {
    dispatch((0, _setSceneLayers["default"])(sceneLayers));
  };
}
var _default = exports["default"] = syncSceneLayers;